/**
 * @name checkResponseError
 * @description Zkontroluje odpověď serveru, v případě nevalidní odpovědi vyhodí chybu.
 *
 * @param {number} responseStatus Úspěšný status je 200, cokoli jiného vyhodí chybu.
 */
export const checkResponseError = (responseStatus: number) => {
  if (responseStatus !== 200) {
    throw new Error('Špatná odpověď serveru.');
  }
};

/**
 * @name checkDataError
 * @description Zkontroluje data odpovědi ze serveru, v případě nevalidních vyhodí chybu.
 *
 * @param {String} dataStatus Úspěšný status je 'true', cokoli jiného vyhodí chybu.
 */
export const checkDataError = (dataStatus: string) => {
  if (dataStatus !== 'true') {
    throw new Error('Problém s daty.');
  }
};

/**
 * @name handleError
 * @description Vypisuje text chyby do konzole a zobrazí chybovou hlášku vedle celkového počtu hlasů.
 *
 * @param {String} errorMessage
 * @param {HTMLElement} errorElement
 */
export const handleError = (errorMessage: string, errorElement: HTMLElement) => {
  console.log('Chyba ankety: ', errorMessage);
  errorElement.innerText = 'Něco se nepovedlo. Zkuste ještě jednou nebo zaktualizujte stránku.';
};
